'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dSignals$0024 from "./presto.-Signals$.js";
var $p;
/** @constructor */
function $c_Lpresto_Mediator$$anon$18(request$2, bus$2, results$2, busy$4, tmp$2, outer) {
  this.b6J = null;
  this.b6I = null;
  this.a8h = null;
  this.a8g = null;
  this.b6K = null;
  this.b6J = request$2;
  this.b6I = bus$2;
  this.a8h = results$2;
  this.a8g = busy$4;
  this.b6K = tmp$2;
  if ((outer === null)) {
    throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_NullPointerException__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_NullPointerException());
  }
}
export { $c_Lpresto_Mediator$$anon$18 as $c_Lpresto_Mediator$$anon$18 };
$p = $c_Lpresto_Mediator$$anon$18.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_Mediator$$anon$18;
/** @constructor */
function $h_Lpresto_Mediator$$anon$18() {
}
export { $h_Lpresto_Mediator$$anon$18 as $h_Lpresto_Mediator$$anon$18 };
$h_Lpresto_Mediator$$anon$18.prototype = $p;
$p.afx = (function() {
  return this.b6I.bp;
});
$p.a3s = (function() {
  return this.a8h.bj;
});
$p.afF = (function() {
  $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lcom_raquo_laminar_api_package$();
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lcom_raquo_laminar_api_Implicits$RichSource$().b7(this.b6K, this.a8h);
});
$p.acf = (function() {
  return $j_presto$002e$002dSignals$0024.$m_Lpresto_Signals$().oS(this.a8g, this.b6J, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction2(((_$11, _$12) => ((!(!_$11)) || _$12.mk()))));
});
$p.A6 = (function() {
  return this.a8g.R();
});
$p.cPn = (function() {
  return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lcom_raquo_airstream_misc_MapStream(this.a3s(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((_$13) => _$13.dj())), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_None$());
});
$p.cLX = (function() {
  return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lcom_raquo_airstream_misc_MapStream(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lcom_raquo_airstream_misc_FilterStream(this.cPn(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((_$14) => (!_$14.k())))), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((_$15) => _$15.q())), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_None$());
});
$p.cDE = (function() {
  return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lcom_raquo_airstream_misc_MapStream(this.a3s(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((_$16) => _$16.cvF().cPr().dj())), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_None$());
});
$p.aeo = (function() {
  return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lcom_raquo_airstream_misc_MapStream(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lcom_raquo_airstream_misc_FilterStream(this.cDE(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((_$17) => (!_$17.k())))), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((_$18) => _$18.q())), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_None$());
});
var $d_Lpresto_Mediator$$anon$18 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_Mediator$$anon$18, "presto.Mediator$$anon$18", ({
  MA: 1,
  MB: 1
}));
export { $d_Lpresto_Mediator$$anon$18 as $d_Lpresto_Mediator$$anon$18 };
//# sourceMappingURL=presto.-Mediator$$anon$18.js.map
